import { ArrowLeftIcon, ArrowRightIcon, PresentationChartBarIcon } from '@heroicons/react/24/outline'
import { useSelector } from 'react-redux'
import ProgressBar from './ProgressBar'
import { PageType } from '../NawImmoraum'
import props from '../../../../redux/props'
import { NAWSurvey } from '../../../../types/NAW/Survey'
import Button from '../../../UI/Button/Button'
import { Save } from '../../../hooks/NAW/useNAWSurveyAnswer/useNAWSurveyAnswer'

type Props = {
  survey: NAWSurvey
  pages: PageType[]
  currentPage: PageType
  setCurrentPage: (e: PageType) => void
  save: Save
}

const Navigation: React.FC<Props> = ({ pages, currentPage, setCurrentPage, save }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getCurrentIndex = () => {
    return pages.findIndex((cP) => cP === currentPage)
  }

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  const next = () => {
    if (getCurrentIndex() < pages.length - 1) {
      const nextPage = pages[getCurrentIndex() + 1]
      save(nextPage)
      setCurrentPage(nextPage)
      scrollToTop()
    }
  }

  const previous = () => {
    if (getCurrentIndex() > 0) {
      setCurrentPage(pages[getCurrentIndex() - 1])
      scrollToTop()
    }
  }

  const isNextDisabled = () => {
    return getCurrentIndex() === pages.length - 1
  }

  const isFirstPage = () => {
    return getCurrentIndex() === 0
  }

  const isPrePromoPage = () => {
    return currentPage === PageType.SUMMARY
  }

  const isLastPage = () => {
    return currentPage === PageType.PROMO
  }

  if (!currentPage) return null
  return (
    <div className="flex flex-row justify-center mt-5 md:absolute bottom-5 w-full">
      {!isLastPage() && (
        <div className="flex gap-3">
          {!isFirstPage() && !isPrePromoPage() && (
            <Button
              onClick={previous}
              disabled={getCurrentIndex() === 0}
              className="w-fit !p-0 border-none"
              text={
                <div className="px-10 py-2 bg-green">
                  <ArrowLeftIcon className="w-6 stroke-white" />
                </div>
              }
            />
          )}
          {!isNextDisabled() && !isFirstPage() && !isPrePromoPage() && (
            <Button
              onClick={next}
              className="w-fit !p-0 border-none"
              text={
                <div className="px-10 py-2 bg-green">
                  {currentPage === PageType.FLAECHE ? (
                    <PresentationChartBarIcon className="w-6 stroke-white" />
                  ) : (
                    <ArrowRightIcon className="w-6 stroke-white" />
                  )}
                </div>
              }
            />
          )}
          {!isNextDisabled() && isFirstPage() && !isPrePromoPage() && (
            <Button
              onClick={next}
              className="w-fit !p-0 border-none"
              text={<div className="px-10 py-2 text-white text-lg bg-green border-none">{t.naw.survey.answer.navigation.start}</div>}
            />
          )}
        </div>
      )}
      <ProgressBar pages={pages} currentPage={currentPage} />
    </div>
  )
}

export default Navigation
